import ChatProvider from '../store/schema/ChatProvider';
import getSipUri from './getSipUri';
import isSignedIn from './isSignedIn';
import { getStore } from '../store/chatStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { default as subscribePresenceFromUcma } from '../ucma/presenceManager/subscribePresence';
import { default as subscribePresenceFromUcwa } from '../ucwa/presenceManager/subscribePresence';

// This function is used to update the presence in
// 1. RP sender image in expanded/collapsed item part
// 2. Compose readwrite recipient well
export default function tryRegisterForPresenceUpdates(imAddress: string) {
    if (!isFeatureEnabled('fwk-skypeBusinessV2')) {
        return;
    }

    if (!imAddress) {
        return;
    }

    const sipUri = getSipUri(imAddress);

    switch (getStore().chatProvider) {
        case ChatProvider.UCWA:
            subscribePresenceFromUcwa(sipUri);
            break;

        case ChatProvider.UCMA:
        case ChatProvider.Teams:
            if (isSignedIn()) {
                subscribePresenceFromUcma(sipUri);
            }

            break;
    }
}
